export default __webpack_public_path__ + "alberta-star.73e078dc2f2073aba6e6.svg";